const csc = [
    {
        depth2: '전체메뉴',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '전체메뉴',
        type: 'POPUP',
        dir: 'etc',
        id: 'SC-ETC-0000-P',
        plan: '25.06.13',
        end: '25.06.12',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '공지사항',
        depth3: '목록',
        depth4: '',
        depth5: '',
        name: '공지사항 목록',
        type: 'PAGE',
        dir: 'etc',
        id: 'SC-ETC-1002-F',
        plan: '25.07.30',
        end: '25.07.30',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '공지사항',
        depth3: '상세',
        depth4: '',
        depth5: '',
        name: '공지사항 상세',
        type: 'PAGE',
        dir: 'etc',
        id: 'SC-ETC-1003-F',
        plan: '25.07.30',
        end: '25.07.30',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '공지팝업',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '공지팝업',
        type: 'POPUP',
        dir: 'etc',
        id: 'SC-ETC-2000-P',
        plan: '25.06.13',
        end: '25.06.13',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '서비스 점검 안내',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '서비스 점검 안내',
        type: 'PAGE',
        dir: 'etc',
        id: 'SC-ETC-2001-F',
        plan: '25.06.02',
        end: '25.05.27',
        user: '허재성',
        state: '완료',
        etc: '최근소스, 250806: 시작일 종료일 추가',
        uxw: true,
    },
    {
        depth2: '상품별거래시간제어 팝업 ',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '상품별거래시간제어 팝업 ',
        type: 'POPUP',
        dir: 'etc',
        id: 'SC-ETC-2002-P',
        plan: '25.07.04',
        end: '25.07.02',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '일자전환관리',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '일자전환관리',
        type: 'PAGE',
        dir: 'etc',
        id: 'SC-ETC-2003-F',
        plan: '25.07.25',
        end: '25.07.25',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '지점찾기',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '지점찾기',
        type: 'PAGE',
        dir: 'etc',
        id: 'SC-ETC-3000-F',
        plan: '25.07.02',
        end: '25.06.27',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '관리지점 목록',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '관리지점 목록',
        type: 'POPUP',
        dir: 'etc',
        id: 'SC-ETC-3001-P',
        plan: '25.07.04',
        end: '25.06.30',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '관리지점 선택',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '관리지점 선택',
        type: 'POPUP',
        dir: 'etc',
        id: 'SC-ETC-3002-P',
        plan: '25.07.04',
        end: '25.06.30',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '고객센터',
        depth3: '서비스 소개',
        depth4: '',
        depth5: '',
        name: '이용 안내 서비스 소개',
        type: 'POPUP',
        dir: 'etc',
        id: 'SC-ETC-4000-F',
        plan: '25.04.25',
        end: '25.04.24',
        user: '허재성',
        state: '완료',
        etc: '25.07.15 페이지 전환, 250806: 클래스변경',
        uxw: true,
    },
    {
        depth2: '고객센터',
        depth3: '서비스 소개',
        depth4: '',
        depth5: '',
        name: '이용 안내 서비스 소개',
        type: 'POPUP',
        dir: 'etc',
        id: 'SC-ETC-4000-P',
        plan: '25.04.25',
        end: '25.04.24',
        user: '허재성',
        state: '삭제',
        etc: '최초소스, 250711: 문구수정',
        uxw: true,
    },
    {
        depth2: '고객센터',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '이용 안내',
        type: 'POPUP',
        dir: 'etc',
        id: 'SC-ETC-4001-F',
        plan: '25.04.25',
        end: '25.04.22',
        user: '김익중',
        state: '완료',
        etc: '25.07.15 페이지 전환',
        uxw: true,
    },
    {
        depth2: '고객센터',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '이용 안내',
        type: 'POPUP',
        dir: 'etc',
        id: 'SC-ETC-4001-P',
        plan: '25.04.25',
        end: '25.04.22',
        user: '김익중',
        state: '삭제',
        etc: '최초소스, 250620: 꼭알아두세요. 하단버튼 추가 / ux라이팅 반영',
        uxw: true,
    },
    {
        depth2: '고객센터',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '자주묻는질문',
        type: 'POPUP',
        dir: 'etc',
        id: 'SC-ETC-4011-F',
        plan: '25.04.30',
        end: '25.04.22',
        user: '김익중',
        state: '완료',
        etc: '25.07.15 페이지 전환',
        uxw: true,
    },
    {
        depth2: '고객센터',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '자주묻는질문',
        type: 'POPUP',
        dir: 'etc',
        id: 'SC-ETC-4011-P',
        plan: '25.04.30',
        end: '25.04.22',
        user: '김익중',
        state: '삭제',
        etc: '250428: 필터 기능 추가, 250514: 띄어쓰기 수정',
        uxw: true,
    },
    {
        depth2: '고객센터',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '고객센터 IBK 큐브 100% 활용법',
        type: 'POPUP',
        dir: 'etc',
        id: 'SC-ETC-4021-F',
        plan: '25.04.30',
        end: '25.04.23',
        user: '김익중',
        state: '완료',
        etc: '25.07.15 페이지 전환, 25.07.21 기획/디자인 수정, 250909 기획/디자인 수정',
        uxw: true,
    },
    {
        depth2: '고객센터',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '고객센터 IBK 큐브 100% 활용법',
        type: 'POPUP',
        dir: 'etc',
        id: 'SC-ETC-4021-P',
        plan: '25.04.30',
        end: '25.04.23',
        user: '김익중',
        state: '삭제',
        etc: '추후 이미지 변경예정, 25.06.26 사용 라이브러리 수정',
    },
    {
        depth2: '고객센터',
        depth3: '',
        depth4: '',
        depth5: '',
        name: 'IBK 큐브 고객센터',
        type: 'PAGE',
        dir: 'etc',
        id: 'SC-ETC-4022-F',
        plan: '25.04.30',
        end: '25.04.23',
        user: '허재성',
        state: '완료',
        etc: '250508: 정보관리 영역 추가, 250514: 마침표누락 수정, 250618:문구수정, 25.07.22 문구수정, 250723:개인정보처리방침 추가',
        uxw: true,
    },
    {
        depth2: '이벤트',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '이벤트',
        type: 'PAGE',
        dir: 'etc',
        id: 'SC-ETC-1000-F',
        plan: '25.05.28',
        end: '25.05.27',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '이벤트',
        depth3: '이벤트상세',
        depth4: '',
        depth5: '',
        name: '이벤트상세',
        type: 'PAGE',
        dir: 'etc',
        id: 'SC-ETC-1001-F',
        plan: '25.05.28',
        end: '25.05.27',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '신청내역조회',
        depth3: '신청내역',
        depth4: '진행내역',
        depth5: '',
        name: '신청내역조회 진행내역',
        type: 'PAGE',
        dir: 'etc',
        id: 'SC-ETC-5011-F',
        plan: '25.05.30',
        end: '25.05.23',
        user: '허재성',
        state: '완료',
        etc: '25.05.23: SC-ETC-5012-F 포함, 250623: UX Writing (v1.2)수정,250702: 시간문구수정, 250721:클레스 수정',
        uxw: true,
    },
    {
        depth2: '이어가기',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '이어가기',
        type: 'PAGE',
        dir: 'etc',
        id: 'SC-ETC-6000-F',
        plan: '25.06.05',
        end: '25.06.04',
        user: '김익중',
        state: '완료',
        etc: '25.06.04 최초완료, 25.06.24 하단버튼 수정, 25.08.25 기획수정',
        uxw: true,
    },
    {
        depth2: '이어가기',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '이어가기',
        type: 'PAGE',
        dir: 'etc',
        id: 'SC-ETC-6000-F1',
        plan: '25.06.05',
        end: '25.06.04',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '모바일 이용 안내',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '모바일 이용 안내 팝업',
        type: 'POPUP',
        dir: 'etc',
        id: 'SC-ETC-7000-P',
        plan: '25.07.18',
        end: '25.06.11',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '유입경로오류',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '유입경로오류',
        type: 'PAGE',
        dir: 'etc',
        id: 'SC-ETC-8000-F',
        plan: '25.07.10',
        end: '25.07.10',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
]

export default csc
